import Vue from 'vue'
import Router from 'vue-router'
import { setFadeOutBody } from '@/common/utils/common'
import memberRoutes from '@/router/memberRoutes'
import adultRoutes from '@/router/adultRoutes'
import otherRoutes from '@/router/otherRoutes'
import errorRoutes from '@/router/errorRoutes'
import settingRoutes from '@/router/settingRoutes'
import categoryRoutes from '@/router/categoryRoutes'
import gnbRoutes from '@/router/gnbRoutes'
import myRoutes from '@/router/myRoutes'
import listRoutes from '@/router/listRoutes'
import customerRoutes from '@/router/customerRoutes'
import voucherRoutes from '@/router/voucherRoutes'
import playerRoutes from '@/router/playerRoutes'
import accountRoutes from '@/router/accountRoutes'
import searchRoutes from '@/router/searchRoutes'
import redirectRoutes from '@/router/redirectRoutes'
import otherInTheMainLayoutRoutes from '@/router/otherInTheMainLayoutRoutes'
import conferenceRoutes from '@/router/conferenceRoutes'
import astroRoutes from '@/router/astroRoutes'
import companyCustomerRoutes from '@/router/companyCustomerRoutes'
import termsRoutes from '@/router/termsRoutes'
import streamRoutes from '@/router/streamRoutes'
import homeRoutes from '@/router/homeRoutes'
import listViewMoreRoutes from '@/router/listViewMoreRoutes'
import partnerConnectionRoutes from '@/router/partnerConnectionRoutes'
import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'
import revocationPromotionRoutes from '@/router/revocationPromotionRoutes'

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      components: {
        mainLayout: () => import('@/pages/section/MainLayout'),
      },
      children: [
        // app-header, app-footer Om
        ...homeRoutes,
        ...categoryRoutes,
        ...listViewMoreRoutes,
        ...gnbRoutes,
        ...myRoutes,
        ...listRoutes,
        ...customerRoutes,
        ...voucherRoutes,
        ...playerRoutes,
        ...accountRoutes,
        ...searchRoutes,
        ...redirectRoutes,
        ...otherInTheMainLayoutRoutes,
        // ...baseballRoutes,
      ],
    },
    ...conferenceRoutes,
    ...astroRoutes,
    // app-header, app-footer X
    ...memberRoutes,
    ...adultRoutes,
    ...settingRoutes,
    ...otherRoutes,
    ...companyCustomerRoutes,
    ...termsRoutes,
    ...errorRoutes,
    ...streamRoutes,
    ...partnerConnectionRoutes,
    ...revocationPromotionRoutes,
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.name === PATH_NAME_PLAYER_STREAM) {
    await setFadeOutBody()
  }

  next()
})
export default router
